import { createSlice } from "@reduxjs/toolkit";

export const LoginStatusSlice = createSlice({
    name:"loginStatusSlice",
    initialState:{
        status:"denied",
        responseState: 0
    },
    reducers:{
        SET_LOGIN_STATUS:(state, action)=>{
            if(action.payload===null || action.payload===undefined) return
            if(action.payload.status==="denied"){
                state.status = "denied"
                state.responseState = action.payload.responseState
                localStorage.removeItem('TOKEN')
                localStorage.removeItem('UID')
                return
            }
            state.status=action.payload.status
            state.responseState = action.payload.responseState   
        },
    },
})

export const {
    SET_LOGIN_STATUS
} = LoginStatusSlice.actions

export default LoginStatusSlice.reducer